<template>
    <vue-loader :active="loader.status" :message="loader.message"></vue-loader>
    <div class="wrapperLoginForm">
        <div class="card">
            <div class="card-header">
                <div class="card-label">ADW</div>
                <img alt="Work Alfa Diesel" :src="'/img/favicon.png'">
                <div class="card-title">
                    <div class="card-label">ВХОД</div>
                </div>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <input v-model="formData.phone" :class="{'is-invalid error': formElements.phone.error}" type="tel" @click="resetErrorInput('phone')" @input="formatPhoneNumber" v-on:keyup.enter="login()" placeholder="+7 (___) ___-__-__" maxlength="18">
                    <div class="errorText" v-if="formElements.phone.error && formElements.phone.errorMessage">{{ formElements.phone.errorMessage }}</div>
                </div>
                <div class="form-group">
                    <input v-model="formData.password" :class="{'is-invalid': formElements.password.error}" type="password" @click="resetErrorInput('password')" v-on:keyup.enter="login()">
                    <div class="errorText" v-if="formElements.password.error && formElements.password.errorMessage">{{ formElements.password.errorMessage }}</div>
                </div>
                <button class="btn btn-success btnLogin" @click="login()">Войти</button>
            </div>
        </div>
    </div>
    <!-- <textarea style="width: 100%; height: 150px;">{{ result }}</textarea> -->
    <!-- <textarea style="width: 100%; height: 150px;">{{ user }}</textarea> -->
    <!-- <textarea style="width: 100%; height: 60px;">{{ this.$store.state.isAuthenticated }}</textarea> -->
</template>

<script>
// import sessionCheck from '@/VueWorking/sessionCheck.js';
import useAuth from '@/VueWorking/useAuth.js';
// const { authenticated, user, login } = useAuth();
export default {
    name: 'Login',
    data(){
        return {
            isAuthenticated: parseFloat(localStorage.authenticated),
            loader: {
                status: false,
                message: null,
            },

            formData: {
                phone: null,
                password: null
            },
            formElements: {
                phone: {
                    error: false,
                    errorMessage: '',
                },
                password: {
                    error: false,
                    errorMessage: '',
                },
            },

            result: null,
            user: null,
        }
    },
    mounted() {
        console.log(this.isAuthenticated);
        // this.$store.logout();
        if(this.isAuthenticated == true){ this.$router.push({ path: "/" }); }
    },
    methods: {
        async login(){
            try {
                this.loader.status = true; this.loader.message = 'Выполняем вход';
                let errors = await useAuth().login(this.formData);
                if(errors){
                    for(const [key, value] of Object.entries(errors)){
                        let errorMessage = value[0] == 'validation.required' ? 'Не верно заполнено поле' : value[0];
                        this.formElements[key] = {
                            error: true, 
                            errorMessage: errorMessage
                        };
                    };
                }
                this.loader.status = false; this.loader.message = null;
                this.$router.push({ path: "/" });
            } catch (error) {
                console.log(error);
            }
        },
        resetErrorInput(name){
            if(typeof this.formElements[name] != "undefined" && this.formElements[name].error){
                this.formElements[name] = {error: false, errorMessage: ''};
            }
        },


        formatPhoneNumber(event) {
            const input = event.target;
            let value = input.value.replace(/\D/g, ''); // Удаляем все нецифровые символы
            
            // Если номер начинается с 7 или 8 (российские коды), заменяем на +7
            if (value.startsWith('7') || value.startsWith('8')) {
            value = '7' + value.substring(1);
            } else if (!value.startsWith('7') && value.length > 0) {
            value = '7' + value;
            }
            
            let formattedValue = '+7';
            
            if (value.length > 1) {
            const areaCode = value.substring(1, 4);
            formattedValue += ` (${areaCode}`;
            
            if (value.length > 4) {
                const firstPart = value.substring(4, 7);
                formattedValue += `) ${firstPart}`;
                
                if (value.length > 7) {
                const secondPart = value.substring(7, 9);
                formattedValue += `-${secondPart}`;
                
                if (value.length > 9) {
                    const thirdPart = value.substring(9, 11);
                    formattedValue += `-${thirdPart}`;
                }
                }
            } else {
                formattedValue += ')';
            }
            }
            
            // Обновляем значение в поле ввода
            input.value = formattedValue;
            
            // Возвращаем неформатированное значение для v-model (если используется)
            return value;
        }

    }
}
</script>
